import React from "react";

const WhyUs = ({ whyUs, title, description }) => {
  return (
    <section id="why-us" className="section-spacing bg-white">
      <div className="container">
        <h4 className="fs-4 mb-5 lh-normal bold fst-normal text-uppercase">
          Why Me
        </h4>

        <div className="row">
          <div className="col-md-6 pe-0 pe-md-5 mb-5 mb-md-0">
            <h2 className="fs-1 m-0 lh-normal bold fst-normal">{title}</h2>
            <div className="my-5 py-3">
              <p className="opacity-75 fs-4">{description}</p>
            </div>
            <div className="d-flex">
              <div className="text-center me-5">
                <h2 className="fs-2 fw-bold text-blue fst-normal">150+</h2>
                <p className="fs-4">Happy Clients</p>
              </div>
              <div className="text-center">
                <h2 className="fs-2 fw-bold text-green fst-normal">100+</h2>
                <p className="fs-4">Projects Delivered</p>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex flex-column flex-sm-row justify-content-center">
              <div className="mt-0 mt-sm-5">
                {whyUs.services.slice(0, 2).map((service) => (
                  <div className="box shadow p-4 mb-3 me-sm-3" key={service.id}>
                    <div className="d-flex justify-content-between align-items-center">
                      <i className={`fa-solid ${service.icon} fs-5 mb-3`} />
                      <h2 className="fs-2 m-0 lh-normal semibold fst-normal">
                        {service.id}
                      </h2>
                    </div>
                    <h4 className="fs-4 lh-normal bold fst-normal mb-1">
                      {service.title}
                    </h4>
                    <p className="opacity-75 fs-5">{service.description}</p>
                  </div>
                ))}
              </div>

              <div>
                {whyUs.services.slice(2, 4).map((service) => (
                  <div className="box shadow p-4 mb-3" key={service.id}>
                    <div className="d-flex justify-content-between align-items-center">
                      <i className={`fa-solid ${service.icon} fs-5 mb-3`} />
                      <h2 className="fs-2 m-0 lh-normal semibold fst-normal">
                        {service.id}
                      </h2>
                    </div>
                    <h4 className="fs-4 lh-normal bold fst-normal mb-1">
                      {service.title}
                    </h4>
                    <p className="opacity-75 fs-5">{service.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
